import React from 'react';
import ReactDOM from 'react-dom/client';
import { KnowledgebaseSearchPage } from './KnowledgebaseSearch';
import { SearchResultKnowledgebase } from './IKnowledgebaseSearch';
import '~/styles/main.scss';

interface WindowWithData extends Window {
  data: SearchResultKnowledgebase;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const data = (window as unknown as WindowWithData).data || {};

root.render(
  <React.StrictMode>
    <KnowledgebaseSearchPage
      resultCount={data.resultCount}
      resultDetails={data.resultDetails}
      pageNumber={data.pageNumber}
      pageSize={data.pageSize}
      searchTerm={data.searchTerm}
    />
  </React.StrictMode>
);
